import { flexCenter } from '@anm/styles/helpers';
import styled from 'styled-components';

export const ShowAllButton = styled.div`
  ${flexCenter}
`;

export const ListContainer = styled.div`
  margin-bottom: 20px;
`;
